import React from 'react';
import { useLocation } from 'react-router-dom';
import { FileText, Send } from 'lucide-react';
import { useRedirect } from '../../../Shared/Hooks/useRedirect ';

/**
 * The two Email tabs: the template library ("Email Configuration") and the send surface
 * ("Email Trigger"). Kept in the same order as the tab labels so the active tab never jumps.
 */
export const EMAIL_TEMPLATES_PATH = '/admin/support/email/templates';
export const EMAIL_TRIGGER_PATH = '/admin/support/email/trigger';

const TABS = [
  { label: 'Email Configuration', path: EMAIL_TEMPLATES_PATH, icon: FileText },
  { label: 'Email Trigger', path: EMAIL_TRIGGER_PATH, icon: Send },
];

const EmailTabNav = () => {
  const location = useLocation();
  const redirect = useRedirect();

  return (
    <div className="mb-6 flex flex-wrap gap-2 rounded-2xl border border-slate-800 bg-slate-900/60 p-2">
      {TABS.map((tab) => {
        const active = location.pathname === tab.path;
        const Icon = tab.icon;
        return (
          <button
            key={tab.path}
            onClick={() => redirect(tab.path)}
            className={`inline-flex items-center gap-2 rounded-xl px-3.5 py-2 text-xs font-black uppercase tracking-wider transition ${
              active
                ? 'bg-gradient-to-r from-cyan-500 to-teal-500 text-slate-950 shadow-lg shadow-cyan-500/20'
                : 'border border-slate-800 bg-slate-950/60 text-slate-400 hover:border-cyan-500/40 hover:text-cyan-400'
            }`}
          >
            <Icon size={14} />
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};

export default EmailTabNav;
